import { render, staticRenderFns } from "./MemberCenterSecond.vue?vue&type=template&id=609dab00&scoped=true"
import script from "./MemberCenterSecond.vue?vue&type=script&lang=js"
export * from "./MemberCenterSecond.vue?vue&type=script&lang=js"
import style0 from "./MemberCenterSecond.vue?vue&type=style&index=0&id=609dab00&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "609dab00",
  null
  
)

export default component.exports